import { icon, layer, parse, findIconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faBug } from '@fortawesome/pro-regular-svg-icons';

const resolveIconDefinition = (prefix, iconName) => {
    let definition = findIconDefinition({ prefix: prefix, iconName: iconName });
    
    if( !definition ) {
        console.error("Icon with prefix %s and name %s cannot be found", prefix, iconName);
        // use faBug for missing icons
        definition = faBug;
    }
    
    return definition;
}

const getIcon = (prefix, iconName) => {
    const definition = resolveIconDefinition(prefix, iconName);
    return icon(definition).html[0];
}

const getLayeredIcon = (prefixes, iconNames, classNames, transforms) => {
    if( prefixes.length === 1 ) {
        const prefix = prefixes[0];
        const iconName = iconNames[0];
        const transform = transforms[0];
        const className = classNames[0];
        
        const definition = resolveIconDefinition(prefix, iconName);
        return icon(definition, {
            transform: transform,
            classes: [className]
        }).html[0];
    } else {
        return buildLayeredIcon(prefixes, iconNames, classNames, transforms);
    }
 }
 
 const buildLayeredIcon = (prefixes, iconNames, classNames, transforms) => {
    
    const result = layer((push) => {
        for (let i = 0; i < iconNames.length; i++) {
            const prefix = prefixes[i];
            const iconName = iconNames[i];
            const className = classNames[i];
            const transform = parse.transform(transforms[i]);
            
            const definition = resolveIconDefinition(prefix, iconName);
            
            push(icon(definition, {
                transform: transform,
                classes: [className]
            }));
        }
    });

    const html = result.html;
    return html[0];
}

export {
    getIcon,
    getLayeredIcon
}
